import React, { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Disclosure, /*Menu,*/ Popover, Transition } from '@headlessui/react';
import { v4 as uuidv4 } from 'uuid';

//import { DarkModeSwitch } from 'react-toggle-dark-mode';
import DarkModeToggle from "react-dark-mode-toggle";

import { MenuIcon, UserIcon, XIcon } from '@heroicons/react/outline';
import { useClassNames, useWhiteLabel } from '@metaforcelabs/metaforce-core';

import { Menu, MenuButton } from '../../components/Menu';

import { OidcRoutesContext, TailwindUiContext } from '../../contexts';
import { config } from '../../utils/config';

const TYPES = {
  fullwidth: 'fullwidth',
  maxWidth2x1: 'maxWidth2x1',
  maxWidth3x1: 'maxWidth3x1'
};
const TwUiNavBarSettings = (type, showUser, useDocsIcon, showDarkModeToggle) => {
  return {
    type: type,
    showUser: showUser || true,
    useDocsIcon: useDocsIcon || true,
    showDarkModeToggle: showDarkModeToggle || false
  };
}
TwUiNavBarSettings.types = TYPES;

export { TwUiNavBarSettings }

const UserNavLink = ({item, active}) => {
  const { classNames } = useClassNames();

  return (
    <a
      id={item.id}
      key={item.id}
      onClick={e => {
        item.onClick?.call();
      }}
      href={item.href}
      className={classNames(
        active ? 'bg-gray-100 dark:bg-gray-900' : '',
        'block px-4 py-2 text-sm text-gray-700 cursor-pointer dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
      )}
    >
      {item.name}
    </a> 
  );
}

const MainNavLink = ({item, ...props}) => {
  const { classNames } = useClassNames();

  return (
    <Link
      id={item.id}
      key={`${item.id}MNL${uuidv4()}`}
      to={item.route}
      className={classNames(
        'block rounded-md py-1 px-3 text-sm font-medium',
        !item.icon && item.current
          ? 'bg-gray-300 text-gray-900 dark:bg-gray-900 dark:text-gray-300'
          : 'text-gray-900 hover:bg-gray-100 hover:text-gray-900 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
      )}
    >
      {item.icon || item.name}
    </Link>
  );
};

const SubNavLink = ({item, ...props}) => {
  const { classNames } = useClassNames();

  return (
    <Link
      id={item.id}
      key={`${item.id}SNL${uuidv4()}`}
      to={item.route}
      className={`${
        item.current
          ? 'bg-gray-300 text-gray-900 dark:bg-gray-900 dark:text-gray-300'
          : 'text-gray-900 hover:bg-gray-100 hover:text-gray-900 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
      } block rounded-md py-1 px-3 text-sm font-medium `}
      aria-current={item.current ? 'page' : undefined}
      >
      {item.name}
    </Link>
    );
}

export const TwNavBar = ({ navigation, userNavigation, darkMode, helpUrl, renderExtendedPanel }) => {
  const oidcRoutesContext = useContext(OidcRoutesContext);
  const tailwindUiContext = useContext(TailwindUiContext);
  const { logoUrl } = useWhiteLabel();

  const buildSubmenuOptionSelected = navigation.find(navig => navig.current)?.children;

  const settings = tailwindUiContext?.navbar;

//#region Sub Functions

  const GridIconSendBaseUrl = () => {
    const fillColor = darkMode?.isDarkMode ? "white" : "black";
    const svgData = `<svg xmlns="http://www.w3.org/2000/svg" width='884' height='356' viewBox='0 0 884 356' fill='none'>
      <path d='M143.68 18.1966C128.942 9.63922 111.589 5.28125 92.1503 5.28125H21.6048C15.398 5.28125 10.1685 7.47334 6.1011 11.8049C2.06011 16.0836 0 21.498 0 27.8632V195.472C0 202.075 2.05997 207.542 6.12737 211.715C10.1948 215.915 15.5301 218.054 21.9481 218.054H92.4937C112.17 218.054 129.549 213.643 144.181 204.98C158.84 196.291 170.408 183.745 178.543 167.687C186.651 151.708 190.745 132.823 190.745 111.509C190.745 90.1948 186.572 71.3106 178.385 55.3315C170.144 39.2731 158.47 26.7804 143.706 18.1966H143.68ZM141.646 145.871C137.816 155.326 131.821 162.986 123.765 168.611C115.762 174.211 105.436 177.063 93.1013 177.063H43.5529V46.325H93.1013C105.251 46.325 115.446 49.1247 123.475 54.6183C131.504 60.1383 137.578 67.7977 141.487 77.3587C145.476 87.0782 147.509 98.5673 147.509 111.535C147.509 124.504 145.528 136.257 141.646 145.897V145.871Z' fill='` + fillColor + `' />
      <path d='M400.267 31.5111C380.036 11.5967 351.855 0.609375 320.9 0.609375C289.946 0.609375 262.028 11.4647 241.85 31.2206C222.332 50.2899 210.922 76.8865 209.522 106.336H209.258L209.311 108.924C209.945 139.588 221.354 167.373 241.454 187.155C261.685 207.07 289.866 218.057 320.821 218.057C351.775 218.057 379.693 207.202 399.871 187.446C419.389 168.377 430.799 141.78 432.199 112.357H432.463L432.41 109.769C431.776 79.105 420.367 51.3199 400.267 31.5111ZM387.537 108.765C386.375 148.911 359.567 175.878 320.794 175.878C282.022 175.878 255.927 149.545 254.131 110.297V109.875C255.293 69.7288 282.128 42.7625 320.874 42.7625C359.62 42.7625 385.741 69.095 387.537 108.343V108.765Z' fill='` + fillColor + `' />
      <path d='M679.177 4.41016C666.182 4.41016 657.123 13.892 657.123 27.4412V194.152C657.123 207.728 666.182 217.183 679.177 217.183C692.171 217.183 701.231 207.49 701.231 194.152V27.4412C701.231 14.1033 691.96 4.41016 679.177 4.41016Z' fill='` + fillColor + `' />
      <path d='M867.387 111.642L866.964 111.273H867.73L861.629 107.047C861.418 106.915 861.206 106.783 860.995 106.65L859.437 105.647C846.548 97.2479 831.176 92.3089 817.865 88.5848C788.389 79.9746 772.991 74.8507 772.991 61.1959C772.991 49.1521 785.431 40.7268 803.206 40.7268C823.623 40.7268 834.9 52.1895 839.734 57.0757C840.473 57.8152 840.949 58.3171 841.345 58.6605C851.038 67.6933 860.995 67.2442 870.952 57.287C880.804 47.0657 880.936 37.3725 871.349 26.8342C859.754 13.4699 834.504 0 804.184 0C760.868 0 730.601 27.0457 730.601 65.7652C730.601 82.3518 736.041 95.2934 747.24 105.33L747.662 105.7H746.897L752.998 109.926C753.209 110.058 753.42 110.19 753.632 110.322L755.19 111.325C768.105 119.724 783.45 124.663 796.762 128.387C826.237 136.997 841.635 142.148 841.635 155.776C841.635 167.82 829.195 176.245 811.42 176.245C791.031 176.245 779.726 164.783 774.893 159.896C774.233 159.21 773.678 158.682 773.282 158.312C768.66 154.007 763.985 151.867 759.284 151.867C754.107 151.867 748.877 154.482 743.648 159.712C733.796 169.933 733.664 179.626 743.252 190.164C754.846 203.529 780.096 216.998 810.417 216.998C853.732 216.998 884 189.953 884 151.233C884 134.647 878.559 121.705 867.36 111.669L867.387 111.642Z' fill='` + fillColor + `' />
      <path d='M619.487 8.71586C610.639 1.1357 597.301 2.19218 589.721 11.0401L531.245 79.42L472.77 11.0401C465.19 2.19218 451.878 1.1357 443.004 8.71586C434.13 16.296 433.1 29.6076 440.68 38.4819L503.46 111.933L443.664 181.871C436.084 190.719 437.141 204.057 445.989 211.637C449.977 215.044 454.836 216.708 459.696 216.708C465.665 216.708 471.581 214.199 475.754 209.313L531.219 144.446L586.684 209.313C590.857 214.199 596.773 216.708 602.742 216.708C607.602 216.708 612.461 215.044 616.45 211.637C625.324 204.057 626.354 190.745 618.774 181.871L558.978 111.933L621.758 38.4819C629.339 29.634 628.282 16.296 619.434 8.71586H619.487Z' fill='` + fillColor + `' />
      <path d='M355.387 301.369V331.057H345.084V279.494H355.191V292.287H352.799C354.492 287.665 356.835 284.214 359.83 281.936C362.857 279.624 366.503 278.469 370.768 278.469C374.316 278.469 377.49 279.25 380.289 280.812C383.121 282.342 385.351 284.621 386.979 287.648C388.606 290.676 389.42 294.436 389.42 298.928V331.057H379.117V300.197C379.117 296.063 378.124 292.954 376.139 290.871C374.186 288.755 371.419 287.697 367.838 287.697C365.494 287.697 363.378 288.169 361.49 289.113C359.635 290.057 358.154 291.538 357.047 293.557C355.94 295.575 355.387 298.179 355.387 301.369Z' fill='` + fillColor + `' />
      <path d='M311.113 332.229C306.003 332.229 301.608 331.073 297.93 328.762C294.284 326.451 291.468 323.277 289.482 319.24C287.529 315.171 286.553 310.549 286.553 305.373C286.553 300.1 287.578 295.445 289.629 291.408C291.68 287.339 294.512 284.149 298.125 281.838C301.738 279.494 305.889 278.322 310.576 278.322C314.222 278.322 317.51 278.973 320.439 280.275C323.402 281.577 325.941 283.433 328.057 285.842C330.173 288.218 331.8 291.05 332.939 294.338C334.079 297.626 334.648 301.271 334.648 305.275V308.059H291.191V300.246H329.229L324.688 302.639C324.688 299.449 324.118 296.682 322.979 294.338C321.839 291.962 320.212 290.139 318.096 288.869C316.012 287.567 313.538 286.916 310.674 286.916C307.842 286.916 305.384 287.567 303.301 288.869C301.217 290.139 299.59 291.962 298.418 294.338C297.279 296.682 296.709 299.449 296.709 302.639V307.082C296.709 310.337 297.279 313.218 298.418 315.725C299.557 318.199 301.201 320.135 303.35 321.535C305.531 322.935 308.167 323.635 311.26 323.635C313.506 323.635 315.492 323.293 317.217 322.609C318.942 321.893 320.374 320.917 321.514 319.68C322.653 318.443 323.467 317.01 323.955 315.383H333.867C333.249 318.703 331.865 321.633 329.717 324.172C327.601 326.678 324.932 328.648 321.709 330.08C318.519 331.512 314.987 332.229 311.113 332.229Z' fill='` + fillColor + `' />
      <path d='M246.186 332.229C239.61 332.229 233.783 330.65 228.705 327.492C223.66 324.302 219.688 319.891 216.791 314.26C213.926 308.596 212.494 302.085 212.494 294.729C212.494 287.242 213.943 280.682 216.84 275.051C219.737 269.387 223.725 264.992 228.803 261.867C233.881 258.71 239.659 257.131 246.137 257.131C250.108 257.131 253.835 257.733 257.318 258.938C260.801 260.142 263.894 261.867 266.596 264.113C269.33 266.327 271.592 268.964 273.383 272.023C275.206 275.051 276.394 278.42 276.947 282.131H265.961C265.473 279.885 264.643 277.834 263.471 275.979C262.299 274.123 260.85 272.528 259.125 271.193C257.4 269.859 255.447 268.833 253.266 268.117C251.117 267.401 248.79 267.043 246.283 267.043C241.693 267.043 237.673 268.199 234.223 270.51C230.805 272.821 228.135 276.06 226.215 280.227C224.327 284.361 223.383 289.195 223.383 294.729C223.383 300.23 224.327 305.048 226.215 309.182C228.135 313.316 230.805 316.538 234.223 318.85C237.673 321.161 241.71 322.316 246.332 322.316C250.173 322.316 253.624 321.503 256.684 319.875C259.776 318.215 262.217 315.92 264.008 312.99C265.831 310.061 266.742 306.643 266.742 302.736L269.818 302.932H248.725V293.898H277.436V302.248C277.436 308.042 276.068 313.202 273.334 317.727C270.6 322.219 266.872 325.767 262.152 328.371C257.465 330.943 252.143 332.229 246.186 332.229Z' fill='` + fillColor + `' />
      <path d='M156.174 332.229C151.258 332.229 146.962 331.089 143.283 328.811C139.605 326.532 136.724 323.374 134.641 319.338C132.59 315.269 131.564 310.614 131.564 305.373C131.564 300.067 132.59 295.38 134.641 291.311C136.724 287.242 139.605 284.068 143.283 281.789C146.962 279.478 151.258 278.322 156.174 278.322C159.234 278.322 162.066 278.794 164.67 279.738C167.307 280.65 169.618 281.952 171.604 283.645C173.589 285.305 175.184 287.29 176.389 289.602C177.626 291.88 178.407 294.387 178.732 297.121H168.479C168.218 295.656 167.762 294.322 167.111 293.117C166.46 291.913 165.614 290.871 164.572 289.992C163.531 289.113 162.31 288.43 160.91 287.941C159.543 287.453 157.98 287.209 156.223 287.209C153.26 287.209 150.721 287.958 148.605 289.455C146.49 290.952 144.862 293.068 143.723 295.803C142.583 298.505 142.014 301.695 142.014 305.373C142.014 309.019 142.583 312.193 143.723 314.895C144.862 317.564 146.49 319.647 148.605 321.145C150.721 322.609 153.26 323.342 156.223 323.342C157.98 323.342 159.543 323.114 160.91 322.658C162.277 322.17 163.449 321.486 164.426 320.607C165.402 319.729 166.216 318.687 166.867 317.482C167.518 316.245 168.007 314.878 168.332 313.381H178.732C178.439 316.083 177.674 318.573 176.438 320.852C175.233 323.13 173.622 325.132 171.604 326.857C169.618 328.55 167.307 329.868 164.67 330.812C162.066 331.757 159.234 332.229 156.174 332.229Z' fill='` + fillColor + `' />
      <path d='M98.8145 332.229C93.8991 332.229 89.5859 331.089 85.875 328.811C82.1641 326.532 79.2669 323.374 77.1836 319.338C75.1328 315.301 74.1074 310.646 74.1074 305.373C74.1074 300.035 75.1328 295.347 77.1836 291.311C79.2669 287.242 82.1641 284.068 85.875 281.789C89.5859 279.478 93.8991 278.322 98.8145 278.322C103.73 278.322 108.027 279.478 111.705 281.789C115.416 284.068 118.297 287.242 120.348 291.311C122.431 295.347 123.473 300.035 123.473 305.373C123.473 310.646 122.431 315.301 120.348 319.338C118.297 323.374 115.416 326.532 111.705 328.811C108.027 331.089 103.73 332.229 98.8145 332.229ZM98.8145 323.342C101.744 323.342 104.267 322.609 106.383 321.145C108.531 319.647 110.175 317.548 111.314 314.846C112.486 312.144 113.072 308.986 113.072 305.373C113.072 301.662 112.486 298.456 111.314 295.754C110.175 293.052 108.531 290.952 106.383 289.455C104.267 287.958 101.744 287.209 98.8145 287.209C95.8848 287.209 93.3457 287.958 91.1973 289.455C89.0814 290.92 87.4375 293.02 86.2656 295.754C85.1263 298.456 84.5566 301.662 84.5566 305.373C84.5566 309.019 85.1263 312.193 86.2656 314.895C87.4375 317.564 89.0814 319.647 91.1973 321.145C93.3132 322.609 95.8522 323.342 98.8145 323.342Z' fill='` + fillColor + `' />
      <path d='M30.1758 331.057H12.2559V321.633H29.4922C35.1562 321.633 39.8275 320.559 43.5059 318.41C47.1842 316.262 49.9349 313.169 51.7578 309.133C53.5807 305.064 54.4922 300.214 54.4922 294.582C54.4922 288.951 53.597 284.133 51.8066 280.129C50.0163 276.125 47.3145 273.065 43.7012 270.949C40.1204 268.801 35.6283 267.727 30.2246 267.727H11.8652V258.303H30.9082C38.0371 258.303 44.1732 259.768 49.3164 262.697C54.4922 265.594 58.4635 269.761 61.2305 275.197C63.9974 280.601 65.3809 287.062 65.3809 294.582C65.3809 302.102 63.9811 308.596 61.1816 314.064C58.4147 319.501 54.4108 323.7 49.1699 326.662C43.929 329.592 37.5977 331.057 30.1758 331.057ZM17.4805 258.303V331.057H6.64062V258.303H17.4805Z' fill='` + fillColor + `' />
    </svg>`;
    const svgImg = "data:image/svg+xml," + svgData;
    return (

      <a href={config.centerpointUiBaseUrl} rel="noreferrer" target="_blank" className={''}>
        <img src={svgImg} alt="DOXIS" style={{height: 36 +'px'}} />
      </a>
    );
  };
  // const GridIconSendBaseUrl = () => (
  //   <a href={config.centerpointUiBaseUrl} rel="noreferrer" target="_blank" className={''}>
  //     <CenterpointLogo size={6} colorClass="text-black dark:text-white" />
  //   </a>
  // );

  const getWidthClass = () => {
    if (settings.type === TYPES.maxWidth2x1)
      return 'max-w-screen-2xl ';
    if (settings.type === TYPES.maxWidth3x1)
      return 'max-w-screen-3xl ';
    return '';
  };
//#endregion

  return (
    <header className="sticky top-0 z-10 w-full bg-white shadow dark:bg-gray-700">
      {/* <div className="max-w-screen-2xl mx-auto px-2 sm:px-4 lg:px-8"> */}
      <div className={`${getWidthClass()}mx-auto px-2 sm:px-4 lg:px-8`}>
        <Popover className="flex justify-between h-16">
          <div className="flex px-2 lg:px-0">
            <div className="flex-shrink-0 flex items-center">
              <GridIconSendBaseUrl />
            </div>

            {logoUrl && (
              <div className="ml-6 flex items-center">
                <img src={logoUrl} alt="" className="h-8 w-auto" />
              </div>
            )}

            <nav
              aria-label="Global"
              className="hidden lg:ml-6 lg:flex lg:items-center lg:space-x-4"
            >
              {navigation.filter(x => x.featureEnabled).map(item => (
                <MainNavLink item={item} />
              ))}
            </nav>
          </div>
          <div className="flex-1 flex items-center justify-center px-2 lg:ml-6 lg:justify-end"></div>
          <div className="flex items-center lg:hidden">
            {/* Mobile menu button */}
            <Popover.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-blue dark:text-gray-400 dark:hover:text-gray-500 dark:hover:bg-gray-800">
              <span className="sr-only">Open main menu</span>
              <MenuIcon className="block h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>
          <Transition.Root as={Fragment}>
            <div className="lg:hidden">
              <Transition.Child
                as={Fragment}
                enter="duration-150 ease-out"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="duration-150 ease-in"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Popover.Overlay
                  className="z-20 fixed inset-0 bg-black bg-opacity-25"
                  aria-hidden="true"
                />
              </Transition.Child>

              <Transition.Child
                as={Fragment}
                enter="duration-150 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-150 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Popover.Panel
                  focus
                  className="z-30 absolute top-0 right-0 max-w-none w-full p-2 transition transform origin-top"
                >
                  <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200 dark:bg-gray-700 dark:divide-gray-500">
                    <div className="pt-3 pb-2">
                      <div className="flex items-center justify-between px-4">
                        <GridIconSendBaseUrl />
                        <div className="-mr-2">
                          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-blue dark:bg-gray-700 dark:text-gray-300 dark:hover:text-gray-500 dark:hover:bg-gray-900">
                            <span className="sr-only">Close menu</span>
                            <XIcon className="h-6 w-6" aria-hidden="true" />
                          </Popover.Button>
                        </div>
                      </div>
                      <div className="mt-3 px-2 space-y-1">
                        {navigation.filter(x => x.featureEnabled).map(item =>
                          !item.children ? (
                            <Link
                              key={`${item.name}${uuidv4()}`}
                              to={item.route}
                              className={`${
                                item.current
                                  ? 'bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-300'
                                  : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
                              } block rounded-md py-1 px-3 text-sm font-medium `}
                            >
                              {item.name}
                            </Link>
                          ) : (
                            <Disclosure
                              as="div"
                              key={item.name}
                              className="space-y-1"
                              defaultOpen={item.current}
                            >
                              {({ open }) => (
                                <>
                                  <Disclosure.Button
                                    className={
                                      'text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800 w-full flex items-center px-3 pr-1 py-2 text-left rounded-md focus:outline-none cursor-pointer dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
                                    }
                                  >
                                    <span className="flex-1 ">{item.name}</span>
                                    <svg
                                      className={`${
                                        open ? 'text-gray-400 rotate-90 dark:text-gray-300' : 'text-gray-300 dark:text-gray-500'
                                      } "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150 dark:group-hover:text-gray-500"`}
                                      viewBox="0 0 20 20"
                                      aria-hidden="true"
                                    >
                                      <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                    </svg>
                                  </Disclosure.Button>
                                  <Disclosure.Panel className="space-y-1">
                                    {item.children.map(subItem => (
                                      <Link
                                        key={`${subItem.name}${uuidv4()}`}
                                        to={subItem.route}
                                        className={`${
                                          subItem.current
                                            ? 'bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-300'
                                            : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-300'
                                        } block rounded-md py-1 px-3 text-sm font-medium `}
                                      >
                                        {subItem.name}
                                      </Link>
                                    ))}
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                          )
                        )}
                      </div>
                    </div>
                    <div className="pt-4 pb-2">
                      {oidcRoutesContext?.userProfile &&
                        <div className="flex items-center px-5">
                          <div className="flex-shrink-0">
                            {oidcRoutesContext?.userProfile?.userProfileImage ? (
                              <img
                                className="h-10 w-10 rounded-full"
                                src={oidcRoutesContext?.userProfile?.userProfileImage}
                                alt=""
                              />
                            ) : (
                              <UserIcon className="h-6 w-6 dark:text-gray-300" aria-hidden="true" />
                            )}
                          </div>
                          <div className="ml-3">
                            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
                              <div>{oidcRoutesContext?.customerInfo?.orgNumber}</div>
                              <div>{oidcRoutesContext?.customerInfo?.name}</div>
                            </div>
                            {/* <div className="text-base font-medium text-gray-800 dark:text-gray-200">
                              {oidcRoutesContext?.customerInfo?.name}
                            </div>
                            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
                              {oidcRoutesContext?.customerInfo?.orgNumber}
                            </div> */}
                          </div>
                        </div>
                      }
                      <div className="mt-3 px-2 space-y-1">
                        {userNavigation.filter(x => x != null).map(item => (
                          <UserNavLink item={item} />
                        ))}
                      </div>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition.Child>
            </div>
          </Transition.Root>

          <div className="hidden m:ml-6 lg:flex lg:flex-none sm:items-center text-xs">
            {/* Add panel here */}
            { renderExtendedPanel && 
              <div className='flex border-l border-r border-gray-300 dark:border-gray-600 px-4'>
                {renderExtendedPanel(2, false)}
              </div>
            }
              <div className='mr-4'>
                <a
                  key="help"
                  target='_blank'
                  rel="noreferrer"
                  className="p-2 group flex space-x-2 text-gray-500 hover:text-brand-blue text-sm font-medium cursor-pointer nav-button align-middle inline-block rounded-full dark:text-gray-300 dark:hover:text-brand-blue"
                  href={`${helpUrl}`}
                >
                  <span>Docs</span>
                  <span className='flex text-white group-hover:text-brand-blue dark:text-gray-700'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-3 h-3 self-end mb-1">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                    </svg>
                  </span>
                </a>
              </div>
            { darkMode && settings.showDarkModeToggle &&
              <DarkModeToggle
                className='mr-4'
                onChange={darkMode.changeDarkMode}
                checked={darkMode.isDarkMode}
                size={60}
              />
            }
            {/* Profile dropdown */}
            <Menu
              as="div"
              actions={userNavigation.filter(x => x != null)} 
              buttonElement=
              {
                <MenuButton className="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue hover:bg-blue-400 active:bg-blue-400 nav-button">
                {/* <MenuButton className={`p-1 rounded-full text-black hover:text-white focus:outline-none hover:bg-red-400 active:bg-red-400 nav-button align-middle ${open ? "active" : ""> */}

                  <span className="sr-only">Open user menu</span>
                  {oidcRoutesContext?.userProfile?.userProfileImage ? (
                    <img
                      className="h-8 w-8 rounded-full"
                      src={oidcRoutesContext?.userProfile?.userProfileImage}
                      alt=""
                    />
                  ) : (
                    <UserIcon className="h-6 w-6 text-gray-700 dark:text-gray-300" aria-hidden="true" />
                  )}
                </MenuButton>
              }
              className="ml-4 relative flex-shrink-0"
            />
              <div className="float-right mr-5 ml-4 text-gray-700 dark:text-gray-300">
                <div>{oidcRoutesContext?.customerInfo?.orgNumber}</div>
                <div>{oidcRoutesContext?.customerInfo?.name}</div>
              </div>
          </div>
        </Popover>
      </div>

      {buildSubmenuOptionSelected && (
        // <div className="max-w-screen-2xl mx-auto  mx-auto px-4 sm:px-6">
        <div className={`${getWidthClass()}mx-auto px-4 sm:px-6`}>
          <div className="hidden lg:flex lg:border-t lg:border-gray-200 lg:py-3 lg:dark:border-gray-500">
            <nav className="hidden lg:ml-1 lg:flex lg:justify-between " aria-label="Breadcrumb">
              <div className="hidden sm:block">
                <ol className="flex items-center space-x-4">
                  {buildSubmenuOptionSelected.map((item, index) => {
                    return (
                      <li key={item.name}>
                        <div className={` flex items-center`}>
                          {/* {index !== 0 && (
                            <svg
                              className="flex-shrink-0 h-5 w-5 text-gray-300 m-0"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                            >
                              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                            </svg>
                          )} */}
                          <SubNavLink item={item} />
                        </div>
                      </li>
                    );
                  })}
                </ol>
              </div>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}